module.exports = __webpack_public_path__ + "img/20_94.880748ae.png";